import { apiInstance } from "store/api/axiosApi";
import {
  GET_ACTION_COUNT,
  GET_ACTION_LIST,
  GET_PRODUCT_LINK_DETAILS,
  GET_QUICK_CHECKOUT_DETAILS,
} from "store/api/constApi";

export const getActionCount = (params: any) => {
  return apiInstance.get(GET_ACTION_COUNT, { params });
};

export const getActionList = (payload: any) => {
  return apiInstance.post(GET_ACTION_LIST, payload);
};

export const getProductLinkDetails = (params: any) => {
  return apiInstance.get(GET_PRODUCT_LINK_DETAILS, { params });
};

export const getQuickCheckoutDetails = (params: { slug: string }) => {
  return apiInstance.get(GET_QUICK_CHECKOUT_DETAILS, { params });
};
